module.exports = __webpack_public_path__ + "5ce2b8924cd2c5e4d121095a2603aef8.svg";